import React from 'react';

const TeamSection = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="flex flex-col w-screen bg-swe-purplenormal py-12">
      <div className="flex flex-wrap justify-center items-center">
        <div className="flex items-center gap-10">
          <p className="font-light text-white text-5xl">Devs</p>
          <div className="flex">
            <div className="flex flex-col items-center">
              <a href="https://github.com/elianddb" target="_blank" rel="noopener noreferrer">
                <img
                  className="rotate-3 w-20 h-20 rounded shadow-md transition duration-300 ease-in-out transform hover:scale-110 hover:brightness-110 filter-purple"
                  src="https://avatars.githubusercontent.com/u/64708153?v=4"
                  alt="Avatar 1"
                />
              </a>
              <p className="text-white text-center font-light mt-2 text-2xl">Elian</p>
            </div>
            <div className="flex flex-col ml-8">
              <p className="text-white text-pretty font-extralight mt-6 text-2xl">Frontend</p>
            </div>
          </div>
          <div className="flex">
            <div className="flex flex-col items-center">
              <a href="https://kusumgandham.netlify.app/" target="_blank" rel="noopener noreferrer">
                <img
                  className="-rotate-2 w-20 h-20 rounded shadow-md transition duration-300 ease-in-out transform hover:scale-110 hover:brightness-110 filter-purple"
                  src="https://kusumgandham.netlify.app/me33.jpg"
                  alt="Avatar 2"
                />
              </a>
              <p className="text-white text-center font-light mt-2 text-2xl">Kusum</p>
            </div>
            <div className="flex flex-col ml-8">
              <p className="text-white text-pretty font-extralight mt-6 text-2xl">Backend</p>
            </div>
          </div>
        </div>
      </div>
      <p className="text-center text-white text-pretty font-extralight text-2xl mt-10">
        © Copyright {currentYear} - Rutgers Society of Women Engineers
      </p>
    </div>
  );
};

export default TeamSection;
